// Social Media URLs
export const GITHUB_URL = "https://github.com/zeeshani26";
export const LINKEDIN_URL = "https://www.linkedin.com/in/zeeshanilahi/";
export const EMAIL = "zeeshan02679@gmail.com";
export const PHONE = "+1-240-316-5202";
export const LOCATION = "Indianapolis, USA";

// Resume URLs
export const RESUME_URL_DESKTOP = "https://drive.google.com/file/d/1JaDv4-wOVGpWbsa5esCfPWfMYExY2OGr/view?usp=sharing";
export const RESUME_URL_MOBILE = "https://drive.google.com/file/d/1JaDv4-wOVGpWbsa5esCfPWfMYExY2OGr/view?usp=sharing";

// Project URLs
export const PROJECT_URLS = {
  stylelife: {
    github: "https://github.com/sdekrishan/Style-Life",
    live: "https://stylelife-sdekrishan.vercel.app/",
  },
  nyresa: {
    github: "https://github.com/himanshudestiny/Nyresa",
    live: "https://numerous-governor-3295.netlify.app/",
  },
  properhealth: {
    github: "https://github.com/zeeshani26/unnatural-throat-9914/tree/main/properhealth",
    live: "https://properhealth.netlify.app/",
  },
  hubspot: {
    github: "https://github.com/Mohitnikum/adhesive-cactus-7535",
    live: "https://hupspot.netlify.app/",
  },
  farfetch: {
    github: "https://github.com/zeeshani26/lying-flesh-4692",
    live: "https://guileless-cocada-b7920d.netlify.app",
  },
};

